import { iterableDynamicPaywallBody } from '@inkitt/types-galatea';
import { z } from 'zod';
import { c } from '../../contract';
import { getDynamicOfferResponse, getDynamicPaywallOfferBodyParams } from '../../types/DynamicPaywall/GetOffer';

export const dynamicPaywallRouter = c.router(
  {
    getDynamicPaywallOffer: {
      summary: 'Gets dynamic paywall offer for the user',
      method: 'GET',
      path: '/',
      query: getDynamicPaywallOfferBodyParams,
      responses: {
        200: getDynamicOfferResponse,
      },
    },
    expireOffers: {
      summary: 'Expires the offers for the user',
      method: 'POST',
      path: '/expire',
      body: z.undefined(),
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
    deleteAllOffers: {
      summary: 'Deletes all offers for the user',
      method: 'POST',
      path: '/delete/all',
      body: z.undefined(),
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
    applyOffer: {
      summary: 'Applies an offer to the user',
      method: 'POST',
      path: '/apply',
      body: iterableDynamicPaywallBody,
      responses: {
        200: z.union([
          z.object({ applied: z.literal(true) }),
          z.object({ applied: z.literal(false), reason: z.string() }),
        ]),
      },
    },
    burnOffer: {
      summary: 'Burns (force-expires) a specific offer so it is never shown again',
      method: 'POST',
      path: '/burn',
      body: z.object({
        offerId: z.string(),
      }),
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
  },
  { pathPrefix: '/dynamic-paywall' },
);
